import DefaultLayout from '##/Default';
import List from './List';
import View from './View';
import Pricing from './Pricing';
import Orders from './Orders';

const routes = [
    {
        path: '/properties/:property_id/units',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Units'
    },
    {
        path: '/units/:unit_id/view',
        exact: true,
        layout: DefaultLayout,
        component: View,
        auth: true,
        title: 'Units'
    },
    {
        path: '/properties/:property_id/units/:unit_id/orders',
        exact: true,
        layout: DefaultLayout,
        component: Orders,
        auth: true,
        title: 'Units'
    },
    {
        path: '/properties/:property_id/reports/pricing',
        exact: true,
        layout: DefaultLayout,
        component: Pricing,
        auth: true,
        title: 'Units'
    }

];

export default routes;
